import { useState } from "react";
import TestimonialCard from "../testimonial-card/testimonial-card";
import TestimonialData from "../../data/testimonials.json";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import ScrollAnimation from "react-animate-on-scroll";
import "./testimonial-module.css";

export default function TestimonialModule() {
  const quoteArr = TestimonialData;

  const [currentTestimonial, setTestimonial] = useState(0);
  const length = quoteArr.length;

  const nextTestimonial = () => {
    setTestimonial(
      currentTestimonial === length - 1 ? 0 : currentTestimonial + 1
    );
  };

  const prevTestimonial = () => {
    setTestimonial(
      currentTestimonial === 0 ? length - 1 : currentTestimonial - 1
    );
  };

  const selectTestimonial = (e: any) => {
    setTestimonial(Number(e.target.id));
  };

  return (
    <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
      <div className="ae-carousel-container ae-page-container">
      <h2 className="h1 ae-carousel-title">What people say about us</h2>
        {quoteArr.map((testimonial, index) => {
          return (
            <div key={index} aria-roledescription="carousel">
              {index === currentTestimonial && (
                <TestimonialCard
                  name={testimonial.name}
                  title={testimonial.title}
                  quote={testimonial.quote}
                  fromPage={false}
                  index={index}
                  length={length}
                />
              )}
            </div>
          );
        })}
        <div className="ae-carousel-controls">
          <button className="ae-carousel-button" onClick={prevTestimonial} aria-label="previous testimonial">
            <FaChevronLeft className="ae-carousel-chevron" />
          </button>
          <div className="ae-carousel-dot-container">
            {quoteArr.map((arr, index) => (
              <ul
                className={`ae-carousel-dots ${
                  currentTestimonial === Number(arr.key)
                    ? "-active-testimonial-dot"
                    : ""
                }`}
                id={arr.key}
                onClick={selectTestimonial}
                key={index}
              ></ul>
            ))}
          </div>
          <button className="ae-carousel-button" onClick={nextTestimonial} aria-label="next testimonial">
            <FaChevronRight className="ae-carousel-chevron" />
          </button>
        </div>    
      </div>
    </ScrollAnimation>
  );
}
